import { useState } from 'react';
import { DateInput } from '@mantine/dates';
import { notifications } from '@mantine/notifications';
import { useUpdateEntry } from '../../../queries/runsheet-entries';
import { ApiError } from '../../../lib/api-error';
import type { RunsheetEntry } from '../../../types/api';

type Field = 'instrument_date' | 'recording_date';

interface Props {
  entry: RunsheetEntry;
  field: Field;
}

export function InlineCellDate({ entry, field }: Props) {
  const server = entry[field];
  const [value, setValue] = useState<string | null>(server);
  const [lastServer, setLastServer] = useState<string | null>(server);
  const updateM = useUpdateEntry();

  if (lastServer !== server) {
    setLastServer(server);
    setValue(server);
  }

  async function commit(next: string | null) {
    if (next === entry[field]) return;
    try {
      await updateM.mutateAsync({ id: entry.id, patch: { [field]: next } });
    } catch (err) {
      setValue(entry[field]);
      notifications.show({
        color: 'red',
        title: 'Update failed',
        message: err instanceof ApiError ? err.message : 'Retry?',
      });
    }
  }

  return (
    <span data-inline-editor onClick={(e) => e.stopPropagation()}>
      <DateInput
        size="xs"
        variant="unstyled"
        placeholder="—"
        valueFormat="YYYY-MM-DD"
        value={value ?? null}
        onChange={(v) => {
          const next = v ?? null;
          setValue(next);
          void commit(next);
        }}
        clearable
        className="rt-inline-edit-cell"
        styles={{ input: { minHeight: 28, padding: '2px 6px' } }}
      />
    </span>
  );
}
